
import { RadioActionTypes } from './constants';

interface State {
    allRadiobuttonItems: any,
    RadiobuttonItems:any,    
    isloading:boolean,    
    error: any,
}

const INIT_STATE = {
    allRadiobuttonItems: null,
    RadiobuttonItems:null,    
    isloading:true,    
    error: '',
};

const Radio = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {

        case RadioActionTypes.Radiobutton_GET_LIST_LOAD:        
        return { ...state, isloading: true };

        case RadioActionTypes.Radiobutton_GET_LIST_SUCCESS:    
      return {
        ...state,
        isloading: false,
        allRadiobuttonItems: action.payload                    
      };        

        default:
            return state;
    }
};

export default Radio;
